export const style = {
    chip: {
        boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
    },
    avatar: {
        boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
        width: 'auto',
        borderRadius: '20px',
        paddingLeft: '20px',
        paddingRight: '20px',
        borderTopRightRadius: '0',
        borderBottomRightRadius: '0',
    },
    popoverIcon: {
        fontSize: '20px',
        fontWeight: '500',
        paddingRight: '15px',
        paddingTop: '12px'
    },
    issueIcon: {
        float: 'left',
        position: 'relative',
        top: '4px',
        width: '20px',
        textAlign: 'left',
        color: 'lightslategrey',
    },
    issueIconUser: {
        position: 'relative',
        top: '2px'
    },
    popoverSpan: {
        fontSize: '15px',
        position: 'relative',
        top: '-3px'
    },
    popoverInput: {
        width: '300px',
        fontSize: '15px',
        top: '4px',
        border: 'none',
        maxWidth: '300px',
    },
    spanTitle: {
        float: 'left',
        fontSize: '16px',
        width: '340px',
        wordWrap: 'break-word',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        marginTop: '6px',
    },
    tagCustom: {
        float: 'left',
        position: 'relative',
        width: '100%'
    },
}


// WEBPACK FOOTER //
// ./src/components/schedule/issues/style.js